import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-analytics-element-target", "data-analytics-banner-id", "href"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "asBanner_wrapper-text"
}
const _hoisted_4 = { class: "asBanner_text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "asBanner_btn-next" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showBanner)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: _normalizeClass(["asBanner", [`-${_ctx.position}`, `-${_ctx.placement}`, `${_ctx.inDay ? '-inDay' : ''}`, `asBanner_${_ctx.banner.id}`]]),
        "data-cy": "banner",
        "data-analytics": "",
        "data-analytics-element-type": "banner",
        "data-analytics-element-target": _ctx.url,
        "data-analytics-banner-id": _ctx.banner.id,
        href: _ctx.url,
        target: "_blank",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBannerClick && _ctx.onBannerClick(...args))),
        ref: "refBanner"
      }, [
        _createElementVNode("img", {
          src: _ctx.image,
          alt: _ctx.banner.title,
          class: "asBanner_img",
          onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBannerShow && _ctx.onBannerShow(...args)))
        }, null, 40, _hoisted_2),
        (_ctx.showText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.banner.text), 1),
              _hoisted_5
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}